module.exports = __webpack_public_path__ + "img/wo_wellspring.7c1ad255.png";